module.exports = __webpack_public_path__ + "static/media/advanced-option.c294df00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/advanced-option.jpg
// module id = 915
// module chunks = 0